import React, { useEffect, useState } from "react";
import Lottie from "lottie-react";
import lightAnimation from "../animations/loading-light.json";
import darkAnimation from "../animations/loading-dark.json";
import { useTheme } from "../lib/ThemeContext";
import { Logo } from "./Logo";

const DEFAULT_MAX_DURATION_MS = 30_000; // 30 seconds

export function LoadingScreen({ maxDurationMs = DEFAULT_MAX_DURATION_MS }: { maxDurationMs?: number }) {
  const { isDark } = useTheme();
  const [timedOut, setTimedOut] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setTimedOut(true), maxDurationMs);
    return () => clearTimeout(timer);
  }, [maxDurationMs]);

  if (timedOut) {
    return (
      <div className="min-h-dvh bg-bg flex flex-col items-center justify-center gap-6 px-4">
        <Logo size="lg" />
        <p className="text-muted text-center">
          Taking longer than expected. The server may be temporarily unavailable.
        </p>
        <button
          type="button"
          onClick={() => window.location.reload()}
          className="px-5 py-2.5 bg-primary text-white rounded-lg hover:-translate-y-0.5 transition-transform font-medium"
        >
          Reload
        </button>
      </div>
    );
  }

  return (
    <div className="min-h-dvh bg-bg flex flex-col items-center justify-center">
      <Lottie
        animationData={isDark ? darkAnimation : lightAnimation}
        loop
        className="w-96 h-96"
      />
      <Logo size="lg" />
    </div>
  );
}
